/**
 * AES工具类
 */
import CryptoJS from 'crypto-js'
const aeskey = "eparksqdc58start";
const aesiv = "8765432112345678"

const KEY = CryptoJS.enc.Utf8.parse(aeskey); //""中与后台一样 16位 密码
const IV = CryptoJS.enc.Utf8.parse(aesiv); //""中与后台一样   16位
export default {
    encrypt(word) {//加密
        let key = KEY
        let iv = IV
        let srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    decrypt(word) {//解密
        let key = KEY
        let iv = IV
        let base64 = CryptoJS.enc.Base64.parse(word);
        let src = CryptoJS.enc.Base64.stringify(base64);

        var decrypt = CryptoJS.AES.decrypt(src, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    }

}
